/* @flow */
import React from 'react';
import gql from 'graphql-tag';
import {DestinationMessage as DestinationMessageComponent} from '@homeaway/react-urgency-messaging';

import type DestinationMessage from '@homeaway/graphql-traveler-urgency-messaging';

const commonSelectionSet = `
            destinationMessage(assetVersion: 1) {
                iconTitleText {
                    title
                    message
                    icon
                    messageValueType
                }
                iconText {
                    message
                    icon
                    messageValueType
        }
    }
`;

export const fragments = {
    results: gql`
        fragment DestinationMessageResults on Results {
            ${commonSelectionSet}
        }
    `,
    searchResult: gql`
        fragment DestinationMessageSearchResult on SearchResult {
            ${commonSelectionSet}
        }
    `
};

export function Content(destinationMessage: DestinationMessage) {
    return (
        <DestinationMessageComponent
            destinationMessage={destinationMessage}
            size={'l'}
            ariaHidden
        />
    );
}
